module.exports = __webpack_public_path__ + "img/base.deeea1ee.png";